import { useTranslation } from 'react-i18next'

import { IOption } from 'src/muiv5/components/commons/SidePanel/Filters/CheckboxListFilter/CheckboxListFilter'

export const useDayOfWeekEntry = (): IOption[] => {
  const { t } = useTranslation()

  return [
    {
      id: '1',
      label: t('Mon.'),
      description: t('Monday'),
    },
    {
      id: '2',
      label: t('Tue.'),
      description: t('Tuesday'),
    },
    {
      id: '3',
      label: t('Wed.'),
      description: t('Wednesday'),
    },
    {
      id: '4',
      label: t('Thu.'),
      description: t('Thursday'),
    },
    {
      id: '5',
      label: t('Fri.'),
      description: t('Friday'),
    },
    {
      id: '6',
      label: t('Sat.'),
      description: t('Saturday'),
    },
    {
      id: '7',
      label: t('Sun.'),
      description: t('Sunday'),
    },
  ]
}
